import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.admin.vector');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-admin-vector',
template: templateSource || '',
    styles: [``],
})
export class PortalAdminVectorComponent implements OnInit, OnDestroy {
    @Input() sub: string = 'collections';
    @Input() toastRef: any = null;

    constructor(@Inject( Service) public service: Service) { }

    // ─── 컬렉션 목록 ─────────────────────────────────
    public collections: any[] = [];
    public collectionsTotal: number = 0;
    public collectionsPage: number = 1;
    public collectionsDump: number = 20;
    public collectionsLastPage: number = 1;
    public loading: boolean = false;

    // ─── 파일 보관함 ─────────────────────────────────
    public driveFiles: any[] = [];
    public driveTotal: number = 0;
    public driveLoading: boolean = false;
    public showDeleteFileConfirm: boolean = false;
    public deleteFileName: string = '';
    public openDownloadMenu: string = '';

    // ─── 생성/편집 모달 ───────────────────────────────
    public showCreateModal: boolean = false;
    public editMode: boolean = false;
    public editId: number | null = null;
    public form: any = {
        name: '',
        description: '',
        file_ids: [] as string[],
    };
    public formSaving: boolean = false;

    // ─── 설정 모달 ────────────────────────────────────
    public showSettingsModal: boolean = false;
    public settingsId: number | null = null;
    public settingsForm: any = {
        embedding_model: 'gemini-embedding-001',
        chunk_method: 'recursive',
        chunk_size: 512,
        chunk_overlap: 50,
    };
    public settingsSaving: boolean = false;

    // ─── 업로드된 파일 목록 (파일 선택용) ───────────────
    public uploadedFiles: any[] = [];
    public uploadedFilesLoading: boolean = false;

    // ─── 파일 선택 검색 ───────────────────────────────
    public fileSearchText: string = '';

    // ─── 삭제 확인 ────────────────────────────────────
    public showDeleteConfirm: boolean = false;
    public deleteTargetId: number | null = null;
    public deleteTargetName: string = '';

    // ─── 컬렉션 임베딩 진행 ──────────────────────────
    public collEmbedding: { [key: number]: boolean } = {};
    public collEmbedProgress: { [key: number]: any } = {};

    // ─── 연구자 임베딩 ─────────────────────────────────
    public researcherSourceFiles: any[] = [];
    public researcherSourceLoading: boolean = false;
    public researcherEmbedding: boolean = false;
    public researcherEmbedProgress: any = { current: 0, total: 0 };
    public researcherCollections: any[] = [];
    public researcherCollLoading: boolean = false;
    public showResearcherDeleteConfirm: boolean = false;
    public deleteResearcherCollName: string = '';
    public showResearcherEmbedModal: boolean = false;
    public researcherEmbedSourceFile: string = '';
    private researcherEmbedPollId: any = null;

    // ─── 임베딩 모델 / 청크 방식 옵션 ─────────────────
    public embeddingModels = [
        { value: 'gemini-embedding-001', label: 'Google Gemini Embedding 001' },
    ];

    public chunkMethods = [
        { value: 'recursive', label: 'Recursive Character' },
        { value: 'fixed', label: 'Fixed Size' },
        { value: 'sentence', label: 'Sentence-based' },
        { value: 'semantic', label: 'Semantic Chunking' },
    ];

    public async ngOnInit() {
        await this.service.init();
        if (this.sub === 'researcher') {
            this.sub = 'collections';
        }
        if (this.sub !== 'files' && this.sub !== 'collections') {
            this.sub = 'collections';
        }
        await this.loadCollections();
        await this.loadDriveFiles();
        if (this.sub === 'collections') {
            await this.loadResearcherSourceFiles();
            await this.loadResearcherCollections();
        }
        await this.service.render();
    }

    ngOnDestroy() { }

    private apiUrl(fn: string) {
        return `/wiz/api/page.admin/${fn}`;
    }

    // ═══════════════════════════════════════════════════
    // 컬렉션 목록
    // ═══════════════════════════════════════════════════
    public async loadCollections(page: number = 1) {
        this.loading = true;
        this.collectionsPage = page;
        await this.service.render();

        try {
            const params = new URLSearchParams();
            params.set('page', String(page));
            params.set('dump', String(this.collectionsDump));

            const resp = await fetch(this.apiUrl('vector_collections'), {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200 && json.data) {
                this.collections = json.data.rows || [];
                this.collectionsTotal = json.data.total || 0;
                this.collectionsLastPage = Math.ceil(this.collectionsTotal / this.collectionsDump) || 1;
            }
        } catch (e) {
            this.collections = [];
            this.collectionsTotal = 0;
        }

        this.loading = false;
        await this.service.render();
    }

    public async collectionsPageMove(page: number) {
        if (page < 1 || page > this.collectionsLastPage) return;
        await this.loadCollections(page);
    }

    // ═══════════════════════════════════════════════════
    // 생성/편집 모달
    // ═══════════════════════════════════════════════════
    public async openCreateModal() {
        this.editMode = false;
        this.editId = null;
        this.form = {
            name: '',
            description: '',
            file_ids: [],
        };
        this.fileSearchText = '';
        this.showCreateModal = true;
        await this.loadUploadedFiles();
        await this.service.render();
    }

    public async openEditModal(coll: any) {
        this.editMode = true;
        this.editId = coll.id;
        let fids = coll.file_ids || [];
        if (typeof fids === 'string') {
            try { fids = JSON.parse(fids); } catch { fids = []; }
        }
        this.form = {
            name: coll.name || '',
            description: coll.description || '',
            file_ids: Array.isArray(fids) ? [...fids] : [],
        };
        this.fileSearchText = '';
        this.showCreateModal = true;
        await this.loadUploadedFiles();
        await this.service.render();
    }

    public closeCreateModal() {
        this.showCreateModal = false;
        this.service.render();
    }

    public toggleFileSelection(filename: string) {
        const idx = this.form.file_ids.indexOf(filename);
        if (idx >= 0) {
            this.form.file_ids.splice(idx, 1);
        } else {
            this.form.file_ids.push(filename);
        }
        this.service.render();
    }

    public isFileSelected(filename: string): boolean {
        return this.form.file_ids.includes(filename);
    }

    public get filteredUploadedFiles(): any[] {
        if (!this.fileSearchText) return this.uploadedFiles;
        const q = this.fileSearchText.toLowerCase();
        return this.uploadedFiles.filter((f: any) =>
            (f.filename || '').toLowerCase().includes(q) ||
            (f.original_name || '').toLowerCase().includes(q)
        );
    }

    public async saveCollection() {
        if (!this.form.name.trim()) return;
        this.formSaving = true;
        await this.service.render();

        try {
            const params = new URLSearchParams();
            params.set('name', this.form.name.trim());
            params.set('description', this.form.description || '');
            params.set('file_ids', JSON.stringify(this.form.file_ids));

            if (this.editMode && this.editId) {
                params.set('id', String(this.editId));
                await fetch(this.apiUrl('vector_collection_update'), {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                });
            } else {
                await fetch(this.apiUrl('vector_collection_create'), {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                });
            }
        } catch (e) { }

        this.formSaving = false;
        this.showCreateModal = false;
        await this.loadCollections(this.collectionsPage);
    }

    // ═══════════════════════════════════════════════════
    // 설정 모달
    // ═══════════════════════════════════════════════════
    public async openSettingsModal(coll: any) {
        this.settingsId = coll.id;
        this.settingsForm = {
            embedding_model: coll.embedding_model || 'gemini-embedding-001',
            chunk_method: coll.chunk_method || 'recursive',
            chunk_size: coll.chunk_size || 512,
            chunk_overlap: coll.chunk_overlap || 50,
        };
        this.showSettingsModal = true;
        await this.service.render();
    }

    public closeSettingsModal() {
        this.showSettingsModal = false;
        this.service.render();
    }

    public async saveSettings() {
        if (!this.settingsId) return;
        this.settingsSaving = true;
        await this.service.render();

        try {
            const params = new URLSearchParams();
            params.set('id', String(this.settingsId));
            params.set('embedding_model', this.settingsForm.embedding_model);
            params.set('chunk_method', this.settingsForm.chunk_method);
            params.set('chunk_size', String(this.settingsForm.chunk_size));
            params.set('chunk_overlap', String(this.settingsForm.chunk_overlap));

            await fetch(this.apiUrl('vector_collection_update'), {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
        } catch (e) { }

        this.settingsSaving = false;
        this.showSettingsModal = false;
        await this.loadCollections(this.collectionsPage);
    }

    // ═══════════════════════════════════════════════════
    // 삭제
    // ═══════════════════════════════════════════════════
    public confirmDelete(coll: any) {
        this.deleteTargetId = coll.id;
        this.deleteTargetName = coll.name || '';
        this.showDeleteConfirm = true;
        this.service.render();
    }

    public cancelDelete() {
        this.showDeleteConfirm = false;
        this.deleteTargetId = null;
        this.deleteTargetName = '';
        this.service.render();
    }

    public async executeDelete() {
        if (!this.deleteTargetId) return;
        try {
            const params = new URLSearchParams();
            params.set('id', String(this.deleteTargetId));
            await fetch(this.apiUrl('vector_collection_delete'), {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
        } catch (e) { }
        this.showDeleteConfirm = false;
        this.deleteTargetId = null;
        this.deleteTargetName = '';
        await this.loadCollections(this.collectionsPage);
    }

    // ═══════════════════════════════════════════════════
    // 업로드된 파일 목록 (파일 선택용)
    // ═══════════════════════════════════════════════════
    public async loadUploadedFiles() {
        this.uploadedFilesLoading = true;
        try {
            const resp = await fetch(this.apiUrl('vector_uploaded_files'), {
                method: 'POST',
                credentials: 'include',
            });
            const json = await resp.json();
            if (json?.code === 200 && json.data) {
                this.uploadedFiles = json.data.rows || [];
            }
        } catch (e) {
            this.uploadedFiles = [];
        }
        this.uploadedFilesLoading = false;
    }

    // ═══════════════════════════════════════════════════
    // 파일 보관함
    // ═══════════════════════════════════════════════════
    public async loadDriveFiles() {
        this.driveLoading = true;
        await this.service.render();
        try {
            const resp = await fetch(this.apiUrl('upload_files'), {
                method: 'POST',
                credentials: 'include',
            });
            const json = await resp.json();
            if (json?.code === 200) {
                this.driveFiles = json.data?.files || [];
                this.driveTotal = json.data?.total || 0;
            }
        } catch (e) {
            this.driveFiles = [];
            this.driveTotal = 0;
        }
        this.driveLoading = false;
        await this.service.render();
    }

    public downloadFile(filename: string) {
        window.open(this.apiUrl('upload_file_download') + '?filename=' + encodeURIComponent(filename), '_blank');
    }

    public downloadCsv(filename: string) {
        window.open(this.apiUrl('upload_csv_download') + '?filename=' + encodeURIComponent(filename), '_blank');
    }

    public toggleDownloadMenu(filename: string) {
        this.openDownloadMenu = this.openDownloadMenu === filename ? '' : filename;
        this.service.render();
    }

    public closeDownloadMenu() {
        this.openDownloadMenu = '';
        this.service.render();
    }

    // ─── 파일보관함 → DB 삽입 ───────────────────────
    private updateToast(phase: string, message: string, progress: number = 0, rowCurrent: number = 0, rowTotal: number = 0) {
        if (!this.toastRef) return;
        this.toastRef.show = true;
        this.toastRef.phase = phase;
        this.toastRef.message = message;
        this.toastRef.progress = progress;
        this.toastRef.rowCurrent = rowCurrent;
        this.toastRef.rowTotal = rowTotal;
        this.toastRef.fileIndex = 0;
        this.toastRef.fileTotal = 0;
        this.toastRef.fileName = '';
        if (phase === 'done' || phase === 'error') {
            if (this.toastRef._autoDismiss) this.toastRef._autoDismiss(5000);
        }
        if (this.toastRef._render) this.toastRef._render();
    }

    public isSupportedForDb(filename: string): boolean {
        const ext = (filename || '').toLowerCase();
        return ext.endsWith('.csv') || ext.endsWith('.tsv') || ext.endsWith('.xlsx') || ext.endsWith('.txt');
    }

    private phaseLabel(phase: string): string {
        switch (phase) {
            case 'parsing': return '행 분석 중';
            case 'researcher': return '연구자 처리 중';
            case 'publication': return '성과물 삽입 중';
            case 'publication_author': return '저자 매핑 중';
            case 'keyword': return '키워드 추출 중';
            case 'aggregate': return '집계 갱신 중';
            case 'inserting': return 'DB 적재 중';
            default: return 'DB 적재 중';
        }
    }

    private phaseUnit(phase: string): string {
        switch (phase) {
            case 'parsing': return '행';
            case 'researcher': return '명';
            case 'publication': return '건';
            case 'publication_author': return '건';
            case 'keyword': return '건';
            case 'aggregate': return '명';
            case 'inserting': return '건';
            default: return '행';
        }
    }

    public async startDbInsert(filename: string) {
        if (this.dbInsertingFile) return;
        this.dbInsertingFile = filename;
        this.updateToast('processing', `DB 적재 준비 중: ${filename}`, 0);
        await this.service.render();

        try {
            const form = new FormData();
            form.append('filename', filename);
            form.append('data_type', 'integrated');

            const resp = await fetch(this.apiUrl('process_upload'), {
                method: 'POST',
                body: form,
                credentials: 'include',
            });

            if (!resp.ok) {
                const text = await resp.text();
                try {
                    const json = JSON.parse(text);
                    this.updateToast('error', json?.data?.message || `서버 오류 (${resp.status})`, 0);
                } catch (e) {
                    this.updateToast('error', `서버 오류 (${resp.status})`, 0);
                }
                this.dbInsertingFile = '';
                await this.service.render();
                return;
            }

            const reader = resp.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';
            let finalResult: any = null;
            let finalError: string = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });

                const parts = buffer.split('\n\n');
                buffer = parts.pop() || '';

                for (const part of parts) {
                    for (const line of part.split('\n')) {
                        if (!line.startsWith('data: ')) continue;
                        try {
                            const event = JSON.parse(line.slice(6));
                            switch (event.type) {
                                case 'progress': {
                                    const current = event.current || 0;
                                    const total = event.total || 0;
                                    const phase = event.phase || '';
                                    const label = this.phaseLabel(phase);
                                    const unit = this.phaseUnit(phase);
                                    const msg = `${label}... ${current.toLocaleString()} / ${total.toLocaleString()} ${unit}`;
                                    this.updateToast('processing', msg, 0, current, total);
                                    await this.service.render();
                                    break;
                                }
                                case 'complete':
                                    finalResult = event.data;
                                    break;
                                case 'error':
                                    finalError = event.message || '처리 중 오류 발생';
                                    break;
                            }
                        } catch (e) { }
                    }
                }
            }

            if (finalError) {
                this.updateToast('error', finalError, 0);
            } else if (finalResult) {
                const d = finalResult;
                const rCnt = (d.researcher_inserted || 0) + (d.researcher_updated || 0);
                const pCnt = (d.publication_inserted || 0) + (d.publication_updated || 0);
                this.updateToast('done', `완료: 연구자 ${rCnt.toLocaleString()}건, 성과물 ${pCnt.toLocaleString()}건`, 100);
            }
        } catch (e: any) {
            this.updateToast('error', e?.message || 'DB 삽입 중 오류 발생', 0);
        }

        this.dbInsertingFile = '';
        await this.service.render();
    }

    // ─── DB 업로드 상태 ───────────────────────────
    public dbInsertingFile: string = '';

    // ─── 파일 삭제 ─────────────────────────────────
    public confirmDeleteFile(filename: string) {
        this.deleteFileName = filename;
        this.showDeleteFileConfirm = true;
        this.service.render();
    }

    public cancelDeleteFile() {
        this.showDeleteFileConfirm = false;
        this.deleteFileName = '';
        this.service.render();
    }

    public async executeDeleteFile() {
        if (!this.deleteFileName) return;
        try {
            const params = new URLSearchParams();
            params.set('filename', this.deleteFileName);
            await fetch(this.apiUrl('upload_file_delete'), {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
        } catch (e) { }
        this.showDeleteFileConfirm = false;
        this.deleteFileName = '';
        await this.loadDriveFiles();
    }

    // ═══════════════════════════════════════════════════
    // 상태 UI 헬퍼
    // ═══════════════════════════════════════════════════
    public getEmbeddingStatusLabel(status: string): string {
        switch (status) {
            case 'pending': return '대기';
            case 'processing': return '진행 중';
            case 'completed': return '완료';
            case 'error': return '오류';
            default: return status || '대기';
        }
    }

    public getEmbeddingStatusClass(status: string): string {
        switch (status) {
            case 'pending': return 'bg-gray-100 text-gray-600';
            case 'processing': return 'bg-blue-50 text-blue-700 animate-pulse';
            case 'completed': return 'bg-green-50 text-green-700';
            case 'error': return 'bg-red-50 text-red-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    }

    public getVectorStatusLabel(status: string): string {
        switch (status) {
            case 'pending': return '대기';
            case 'processing': return '삽입 중';
            case 'completed': return '완료';
            case 'error': return '오류';
            default: return status || '대기';
        }
    }

    public getVectorStatusClass(status: string): string {
        switch (status) {
            case 'pending': return 'bg-gray-100 text-gray-600';
            case 'processing': return 'bg-indigo-50 text-indigo-700 animate-pulse';
            case 'completed': return 'bg-green-50 text-green-700';
            case 'error': return 'bg-red-50 text-red-700';
            default: return 'bg-gray-100 text-gray-600';
        }
    }

    public getStepStatusClass(step: string): string {
        switch (step) {
            case 'done': return 'bg-green-100 text-green-700 border-green-200';
            case 'processing': return 'bg-blue-100 text-blue-700 border-blue-200 animate-pulse';
            case 'error': return 'bg-red-100 text-red-700 border-red-200';
            case 'pending': return 'bg-gray-100 text-gray-500 border-gray-200';
            default: return '';
        }
    }

    public getStepStatusLabel(step: string): string {
        switch (step) {
            case 'done': return '✓';
            case 'processing': return '••';
            case 'error': return '!';
            case 'pending': return '-';
            default: return '';
        }
    }

    // ═══════════════════════════════════════════════════
    // 유틸
    // ═══════════════════════════════════════════════════
    public formatDate(dt: string): string {
        if (!dt) return '-';
        try {
            const d = new Date(dt);
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            const h = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${y}-${m}-${day} ${h}:${min}`;
        } catch (e) { return dt; }
    }

    public formatNumber(n: number): string {
        if (!n && n !== 0) return '0';
        return n.toLocaleString();
    }

    public formatSize(bytes: number): string {
        if (!bytes) return '-';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
        return (bytes / 1073741824).toFixed(2) + ' GB';
    }

    public getEmbeddingModelLabel(model: string): string {
        const found = this.embeddingModels.find(m => m.value === model);
        return found ? found.label : (model || '-');
    }

    public getChunkMethodLabel(method: string): string {
        const found = this.chunkMethods.find(m => m.value === method);
        return found ? found.label : (method || '-');
    }

    // ═══════════════════════════════════════════════════
    // 컬렉션 파일 임베딩 + 벡터 삽입
    // ═══════════════════════════════════════════════════
    public async startCollectionEmbed(collId: number) {
        if (this.collEmbedding[collId]) return;
        this.collEmbedding[collId] = true;
        this.collEmbedProgress[collId] = { current: 0, total: 0 };
        await this.service.render();

        const pollId = setInterval(async () => {
            try {
                const params = new URLSearchParams();
                params.set('id', String(collId));
                const resp = await fetch(this.apiUrl('vector_collection_embed_progress'), {
                    method: 'POST', credentials: 'include',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: params.toString(),
                });
                const json = await resp.json();
                if (json?.code === 200 && json.data) {
                    this.collEmbedProgress[collId] = json.data.data || json.data;
                    await this.service.render();
                }
            } catch (e) { }
        }, 2000);

        try {
            const params = new URLSearchParams();
            params.set('id', String(collId));
            const resp = await fetch(this.apiUrl('vector_collection_embed'), {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code === 200) {
                this.collEmbedProgress[collId] = { current: json.data?.total || 0, total: json.data?.total || 0 };
            }
        } catch (e) { }

        clearInterval(pollId);
        delete this.collEmbedding[collId];
        delete this.collEmbedProgress[collId];
        await this.loadCollections(this.collectionsPage);
    }

    public getFileCount(fileIds: any): number {
        if (typeof fileIds === 'string') {
            try { fileIds = JSON.parse(fileIds); } catch { return 0; }
        }
        if (Array.isArray(fileIds)) return fileIds.length;
        return 0;
    }

    // ═══════════════════════════════════════════════════
    // 연구자 임베딩
    // ═══════════════════════════════════════════════════

    public async loadResearcherSourceFiles() {
        this.researcherSourceLoading = true;
        await this.service.render();
        try {
            const resp = await fetch(this.apiUrl('researcher_source_files'), {
                method: 'POST', credentials: 'include',
            });
            const json = await resp.json();
            if (json?.code === 200) {
                this.researcherSourceFiles = json.data?.files || [];
            }
        } catch { this.researcherSourceFiles = []; }
        this.researcherSourceLoading = false;
        await this.service.render();
    }

    public async loadResearcherCollections() {
        this.researcherCollLoading = true;
        await this.service.render();
        try {
            const resp = await fetch(this.apiUrl('researcher_collections'), {
                method: 'POST', credentials: 'include',
            });
            const json = await resp.json();
            if (json?.code === 200) {
                this.researcherCollections = json.data?.collections || [];
            }
        } catch { this.researcherCollections = []; }
        this.researcherCollLoading = false;
        await this.service.render();
    }

    public async startResearcherEmbed(sourceFile: string) {
        if (this.researcherEmbedding) return;
        this.researcherEmbedding = true;
        this.researcherEmbedSourceFile = sourceFile;
        this.researcherEmbedProgress = { current: 0, total: 0 };
        this.showResearcherEmbedModal = true;
        await this.service.render();

        // 진행률 폴링
        this.researcherEmbedPollId = setInterval(async () => {
            try {
                const resp = await fetch(this.apiUrl('researcher_embed_progress'), {
                    method: 'POST', credentials: 'include',
                });
                const json = await resp.json();
                if (json?.code === 200 && json.data?.data) {
                    this.researcherEmbedProgress = json.data.data;
                    await this.service.render();
                }
            } catch { }
        }, 1500);

        try {
            const params = new URLSearchParams();
            params.set('source_file', sourceFile);
            const resp = await fetch(this.apiUrl('researcher_embed_by_file'), {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
            const json = await resp.json();
            if (json?.code !== 200) {
                alert(json?.data?.message || '임베딩 실패');
            }
        } catch (e) {
            alert('임베딩 중 오류 발생');
        }

        if (this.researcherEmbedPollId) {
            clearInterval(this.researcherEmbedPollId);
            this.researcherEmbedPollId = null;
        }
        this.researcherEmbedding = false;
        this.showResearcherEmbedModal = false;
        this.researcherEmbedProgress = { current: 0, total: 0 };
        await this.loadResearcherCollections();
        await this.service.render();
    }

    public async deleteResearcherCollection(name: string) {
        this.showResearcherDeleteConfirm = false;
        try {
            const params = new URLSearchParams();
            params.set('name', name);
            await fetch(this.apiUrl('researcher_collection_delete'), {
                method: 'POST', credentials: 'include',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: params.toString(),
            });
        } catch { }
        await this.loadResearcherCollections();
        await this.service.render();
    }

    public confirmDeleteResearcherColl(name: string) {
        this.deleteResearcherCollName = name;
        this.showResearcherDeleteConfirm = true;
        this.service.render();
    }
}

export default PortalAdminVectorComponent;